import moment from '@/moment-gp'

/* =============================================================================
DB:       Realtime DB
PATH:
PURPOSE:
============================================================================= */

export default {
  modelGetters:  {},
  staticGetters: {},
  listGetters:   {},
  staticActions: {},
  schema: {
    create({ sortidx, name }) {
      return {
        createdAt: moment.currentTimeServer('REALTIMEDB'),
        name:      name || 'Untitled',
        sortidx:   sortidx || 0,
        deleted:   false,
      };
    },
    fields: {
      createdAt: { validate_bolt_type: 'ServerTimestamp' },
      name:      {},
      sortidx:   { required: true, },
      deleted:   {},
    }
  }
};
